import { api } from '.'
import * as Actions from "../redux/constants/Auth";

const profileService = {}
const config = () => {
	return {
		headers: {'Authorization': `${localStorage.getItem(Actions.AUTH_TOKEN)}`}
	}
}
profileService.getProfileId = async function (id) {
	let result = null;
	await api.get(`/api/users/${id}`, config())
			.then(res => {
				result = { ...res.data, error: false, type: res.status}
			})
			.catch(error => {
				result = {data: null, error: true, type: error}
			})
	return result;
}

profileService.putProfile = async function (data) {
	let result = null;
	await api.put(`/api/users/entrepreneurs`, data, config())
			.then(res => {
					result = {data: res.data, error: false, type: res.status}
			})
			.catch(error => {
					result = {data: null, error: true, type: error}
			})
	return result;
}

profileService.putProfileUser = async function (data) {
	let result = null;
	await api.put(`/api/profiles/`, data, config())
			.then(res => {
					result = {data: res.data, error: false, type: res.status}
			})
			.catch(error => {
					result = {data: null, error: true, type: error}
			})
	return result;
}

profileService.linkCpf = async function (userId, cpf, justification) {
	let result = null;
	await api.put(`/api/users/${userId}/cpf`, { cpf, justification }, config())
			.then(res => {
					result = { data: res.data, error: false, type: res.status }
			})
			.catch(error => {
					result = {
						data: error?.response?.data ?? null,
						error: true,
						type: error?.response?.status ?? null,
					}
			})
	return result;
}

export default profileService
